import { Component, OnInit, ViewChild, AfterViewInit, HostBinding, HostListener, Input } from '@angular/core';
import { COLORS } from '../../../shared/colors';
import { BarVerticalComponent } from '@swimlane/ngx-charts';
import { StatisticService } from '../../../shared/services/statistic.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
})
export class ActivityComponent implements AfterViewInit {
  showWeek: boolean = true;
  currentTab: number = 0;

  data = [
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
  ];

  dataWeek = [
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
  ];
  dataMonth = [
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
    { name: '', value: 0 },
  ];

  week: string[] = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  @ViewChild('chart') chart: BarVerticalComponent;
  constructor(private stats: StatisticService, private translate: TranslateService) {
    // get activity data
    stats.getMyStatistic().then((statistics) => {
      let todayTimeStamp = moment();

      this.dataWeek = [];
      for (let day = 0; day < 7; day++) {
        this.dataWeek.unshift({
          name: todayTimeStamp.day().toString(),
          value: statistics[day] || 0,
        });
        todayTimeStamp = todayTimeStamp.subtract(1, 'days');
      }
      this.data = this.dataWeek;
      this.updateChartDimensions();

      todayTimeStamp = moment();

      for (let day = 0; day < 31; day++) {
        if (todayTimeStamp.month() === moment().month() || todayTimeStamp.date() > moment().date()) {
          this.dataMonth.unshift({
            name: todayTimeStamp.date().toString(),
            value: statistics[day] || 0,
          });
          todayTimeStamp = todayTimeStamp.subtract(1, 'days');
        }
      }

      translate.get('GENERAL.daysShort').subscribe((res: string[]) => {
        for (const d of this.dataWeek) {
          d.name = res[d.name];
        }
        if (this.showWeek) {
          this.data = this.dataWeek;
        }
      });
    });
  }

  ngAfterViewInit() {
    this.updateChartDimensions();
  }

  @HostListener('window:resize')
  resizeBy() {
    setTimeout(() => {
      this.updateChartDimensions();
    }, 300);
  }

  yAxisFormatting(value: number) {
    return value.toString();
  }

  updateChartDimensions() {
    if (this.chart && this.chart.dims) {
      this.chart.barPadding = this.chart.dims.width / (this.data.length - 1) - 8;
      this.chart.update();
    } else {
      setTimeout(this.updateChartDimensions, 300);
    }
  }

  colorScheme = {
    domain: [COLORS.main.primary.rgb],
  };

  toggleWeek() {
    this.data = this.dataWeek;
    this.showWeek = true;

    this.updateChartDimensions();
  }

  toggleMonth() {
    this.data = this.dataMonth;
    this.showWeek = false;

    this.updateChartDimensions();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/activity/activity.component.ts